import React from 'react';
import { Box, BoxExtendedProps, Text, TextExtendedProps } from '@common-fe/common-fe';
import styled from 'styled-components';

const StyledTitle = styled(Text)`
  font-family: 'Oswald', serif;
  color: ${({ theme }) => theme.colors.textOnColor};
`;

interface NodeProps {
  Title: React.FC<Omit<TextExtendedProps, 'as'>>;
}
type Props = {
  children: React.ReactNode;
} & BoxExtendedProps;
const BannerItem: React.FC<Props> & NodeProps = ({ children, as, ...styles }) => {
  return (
    <Box
      data-testid="dashboard_banner_item"
      direction="column"
      round="moduleRound"
      background="onDarkModuleBackground"
      pad="spacing16"
      align="center"
      justify="center"
      style={{ position: 'relative' }}
      {...styles}
    >
      {children}
    </Box>
  );
};
BannerItem.Title = StyledTitle;
export default BannerItem;
